<template>
    <div>
        <az-break-title title="Instruções" />

        <div>

            <div class="row mb-3">
                <div class="col col-12 col-md-6">
                    <az-input icon="fas fa-search" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir Instrução
                    </button>
                </div>
            </div>

        </div>

        <div v-if="!lista || !lista.length">
            <az-empty-state icon="fas fa-search" msg="Nenhuma instrução identificada." 
                :action="!search ? 'Incluir Instrução' : ''" :method="incluir" />
		</div>

        <div v-if="lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between hover-bg" 
                    v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>

                        <span class="badge badge-secondary" title="Id">
                            #{{ dado.id_instrucao_operadora }}
                        </span>
                    </span>
                    <span class="d-flex">
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>

                        <div v-else>
                            <span class="badge badge-secondary" title="Ordem">
                                <i class="fa fa-sort" aria-hidden="true"></i>
                                {{ dado.in_regra_ordem }}
                            </span>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <br><br>

        <!-- Modal -->
        <div class="modal fade" id="instrucaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            Instrução
                            <span v-if="item" class="badge badge-secondary ml-2">
                                {{ !item.id_instrucao_operadora ? '(Nova)' : ( '#' + item.id_instrucao_operadora ) }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="row">
                            <div class="col col-12">
                                <az-input 
                                    label="Título"
                                    required 
                                    :validate="validate"
                                    v-model="item.st_titulo" />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col col-12 col-md-2">
                                <az-input 
                                    label="Ordem"
                                    type="number"
                                    required 
                                    :validate="validate"
                                    v-model="item.in_regra_ordem" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input 
                                    label="Data de Início da Vigência"
                                    type="date"
                                    required 
                                    :validate="validate"
                                    v-model="item.dt_data" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input 
                                    label="Plano"
                                    type="select"
                                    optionsMode="aql"
                                    :optionsSync="false"
                                    service="planos.index"
                                    optionsData="id_plano"
                                    optionsDisplay="search"
                                    optionsName="planos-regra"
                                    :optionsReload="true"
                                    :optionsParm="{ where: { id_operadora: this.id_operadora } }"
                                    :validate="validate"
                                    v-model="item.id_plano" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12">
                                <az-input 
                                    label="Instrução"
                                    type="textarea"
                                    required 
                                    :validate="validate"
                                    v-model="item.st_descricao" />
                            </div>
                        </div>

                        <az-sub-title title="Notificar" />
                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    sizing="sm" 
                                    label="CallCenter"
                                    type="checkbox-group"
                                    :validate="validate"
                                    v-model="item.fl_exibe_callcenter" />
                            </div>
                            <div class="col col-12" :class="item.fl_exibe_recepcao ? 'col-md-3' : 'col-md-6'">
                                <az-input
                                    sizing="sm" 
                                    label="Recepção"
                                    type="checkbox-group"
                                    :validate="validate"
                                    v-model="item.fl_exibe_recepcao" />
                            </div>
                            <div class="col col-12 col-md-3" v-if="item.fl_exibe_recepcao">
                                <az-input
                                    sizing="sm" 
                                    label="Popup"
                                    type="checkbox-group"
                                    :validate="validate"
                                    v-model="item.fl_popup_recep" />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    sizing="sm" 
                                    label="Agenda On-Line / Paciente"
                                    type="checkbox-group"
                                    :validate="validate"
                                    v-model="item.fl_exibe_agenda_online" />
                            </div>
                            <div class="col col-12" :class="item.fl_exibe_orcamento ? 'col-md-3' : 'col-md-6'">
                                <az-input
                                    sizing="sm" 
                                    label="Orçamento"
                                    type="checkbox-group"
                                    :validate="validate"
                                    v-model="item.fl_exibe_orcamento" />
                            </div>
                            <div class="col col-12 col-md-3" v-if="item.fl_exibe_orcamento">
                                <az-input
                                    sizing="sm" 
                                    label="Popup"
                                    type="checkbox-group"
                                    :validate="validate"
                                    v-model="item.fl_popup_orc" />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    sizing="sm" 
                                    label="Faturamento"
                                    type="checkbox-group"
                                    :validate="validate"
                                    v-model="item.fl_exibe_faturamento" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input
                                    sizing="sm" 
                                    label="Prontuário"
                                    type="checkbox-group"
                                    :validate="validate"
                                    v-model="item.fl_exibe_pep" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    sizing="sm" 
                                    label="Autorização"
                                    type="checkbox-group"
                                    :validate="validate"
                                    v-model="item.fl_exibe_autorizacao" />
                            </div>

                            <div class="col col-12 col-md-6" v-if="operadora && operadora.fl_sus">
                                <az-input
                                    sizing="sm" 
                                    label="LEA"
                                    type="checkbox-group"
                                    :validate="validate"
                                    v-model="item.fl_exibe_lea" />
                            </div>
                        </div>

                        <div class="alert alert-warning p-2" v-if="item.fl_exibe_agenda_online">
                            <i class="fa-solid fa-triangle-exclamation mr-2"></i>
                            <strong>Atenção! Essa informação ficará visível para o paciente!</strong> 
                            <div class="small">Ao marcar a opção "Agenda On-Line / Paciente", a instrução será exibida na agenda online e na comunicação com o paciente.</div>
                        </div>

                        <!-- Filtros de Exibição da Recepção -->
                        <div class="mt-3">
                            <filtro-model 
                                v-model="item.filtros" 
                                :validate="validate" 
                                :opcoes="lista_opcoes_filtro" />
                        </div>

                        <br><br><br><br><br>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button :id="item.id_instrucao_operadora" model="instrucaoOperadora" v-if="item" />
                        <az-submit @click="remover ()" color="outline-danger" v-if="false">Remover</az-submit>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzBreakTitle from '../../../util/AzBreakTitle.vue';
import AzEmptyState from '../../../util/AzEmptyState.vue';
import AzInput from '../../../shared/forms/AzInput.vue';
import AzSubTitle from '../../../util/AzSubTitle.vue';
import AzSubmit from '../../../util/AzSubmit.vue';
import FiltroModel from '../../shared/FiltroModel.vue';
import AzAuditLogButton from '../../../util/AzAuditLogButton.vue';

export default {
    data () { 
        return { 
            dados: null, 
            search: "", 
            item: null, 
            validate: false,
            viewMode: "A", 
        }
    },

    components: { 
        AzBreakTitle,
        AzEmptyState,
        AzInput,
        AzSubTitle,
        AzSubmit,
        FiltroModel,
        AzAuditLogButton
    }, 

    props: ['id_operadora', 'operadora'],

    computed: { 
        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter(item => this.viewMode == 'T' || item.fl_ativo)
                    .filter (item => { 
                        return !this.search || reg.test(JSON.stringify(item));
                    }) : null ; 
        },

        lista_opcoes_filtro: function () {
            /*
            let opcoes = [
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true},
                {id:'App\\azure\\unidadeOperacao', search:'Unidade', service:'unidade_operacaos.index'},
            ];
            */

            let opcoes = [                        
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
                {id:'App\\azure\\unidadeOperacao', search:'Unidade', service:'unidade_operacaos.index'},
            ];

            return _.orderBy(opcoes, 'search');
        },
    },

    methods: { 
        incluir () { 
            this.validate = false;

            this.item = { 
                id_operadora: this.id_operadora,
                id_instrucao_operadora: null, 
                fl_ativo: true,
                fl_exibe_callcenter: true, 
                fl_exibe_faturamento: true,
                fl_exibe_recepcao: true,
                st_descricao: "", 
                st_titulo: "",
                id_plano: null, 
                filtros: [], 
                in_regra_ordem: 100, 
            }

            $('#instrucaoModal').modal('show');
        },

        remover () { 

            if ( confirm ('Confirma remover essa instrução?') ) { 

                this.$store.commit('loading', true);

                    let query = { q: [ 
                        {
                            name: 'instrucao_operadoras.destroy',
                            id: 'atualizar',
                            parms: { 
                                id_instrucao_operadora: this.item.id_instrucao_operadora,
                            }
                        }
                    ]};

                    this.axios.post('/aql', query)
                        .then(res => { 
                            if ( res.data.atualizar.status == 200 ) { 
                                this.load ();
                                $('#instrucaoModal').modal('hide');
                            }
                        })
                        .finally(() => { 
                            this.$store.commit('loading', false);
                        });

            }

        },

        atualizar () { 

            this.$util.atualizar(this, { 
                service: 'instrucao_operadoras',
                func: 'store',
                dados: this.item,
                modal: 'instrucaoModal',
                reload: true, 
            });

        },

        toggle (item) { 

            this.$store.commit('loading', true);
            
            let query = { q: [ 
                {
                    name: 'instrucao_operadoras.toggle',
                    id: 'toggle',
                    parms: { 
                        ...item, 
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.toggle.status == 200 ) { 
                        //
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });

        },

        editar (item) { 

            this.validate = false;
            this.item = { ...item };

            $('#instrucaoModal').modal('show');

        },

        load () { 
            this.$store.commit('loading', true);

            let query = { q: [ 
                { 
                    name: 'instrucao_operadoras.index',
                    id: 'lista',
                    parms: { 
                        where: { 
                            id_operadora: this.id_operadora,
                        },
                        cadastro: this.id_operadora == 1, 
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.lista.status == 200 ) { 
                        this.dados = res.data.lista.data; 
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });
        }
    },

    created () { 
        this.$store.commit('loading', true);
    },

    mounted () { 
        this.load (); 
    }
}
</script>